/**
 * Fields stamped by the service / lifecycle / audit — never required from the
 * caller (form, import, assistant). Canonical list; console import engine keeps
 * a mirrored copy (engine may only import `@rammetec/data-access`) and a test
 * asserts the two stay equal (request 0320).
 */
export const SERVICE_FILLED_NAMES = new Set([
    'id',
    'organizationId',
    'version',
    'active',
    'inclusionDate',
    'lastModifiedDate',
    'inclusionUserId',
    'lastModifiedUserId',
    'inactivationDate',
    // ProductGroup hierarchy (request 0347) — stamped by productGroupService
    'path',
    'level',
    'pathDescription',
]);
//# sourceMappingURL=serviceFilledFields.js.map